import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { useNavigate } from "react-router-dom";

import { GenericErrorResponse } from "app/api/types";
import parseError from "app/lib/parseError";
import { BUSHA_ROOT } from "app/constants/routes";
import { listCurrencies } from "app/api/currency";
import { ListCurrenciesQuery } from "app/api/currency/types";

export default function useListCurrencies(query?: ListCurrenciesQuery) {
  const navigte = useNavigate();

  const { isLoading, error, refetch, data } = useQuery(
    ["list-currencies"],
    () => listCurrencies(query),
    {
      onError: (error: AxiosError<GenericErrorResponse>) => {
        if (error.response?.status === 401) {
          navigte(BUSHA_ROOT, { replace: true });
        }
      },
    }
  );

  return {
    isLoading,
    currencies: data?.data.data,
    refetch,
    error: error
      ? (parseError(error as AxiosError<GenericErrorResponse>) as string)
      : undefined,
  };
}
